export function processClickByButtonInPopup(clickedEl, btnInstance, sendTextCall) {
    const elWithSendText = clickedEl.closest('[data-alan-btn-send-text]');
    if (elWithSendText) {
        const text = elWithSendText.getAttribute('data-alan-btn-send-text');
        if (text) {
            sendTextCall(text);
            return;
        }

    }

    const elWithCallProjectApi = clickedEl.closest('[data-alan-btn-call-project-api]');
    if (elWithCallProjectApi) {
        const method = elWithCallProjectApi.getAttribute('data-alan-btn-call-project-api');
        let data = null;
        try {
            data = elWithCallProjectApi.getAttribute('data-alan-btn-project-api-param');
            data = JSON.parse(data);
        } catch (err) {
            console.log('Alan: unable to parse params for calling project api method');
        }

        if (method && btnInstance) {
            btnInstance.callProjectApi(method, data);
            return;
        }

    }
}